// extracted by mini-css-extract-plugin
export default {"select":"Select-module__select--eatbZ","icon":"Select-module__icon--bTNq1","selectWrapper":"Select-module__selectWrapper--uoUim"};